const convertPercentToFraction = (value: number | string, options?: { fixed?: number }) => {
  const { fixed } = options || {};

  const francValue = +value / 100;

  return fixed ? +francValue.toFixed(fixed) : francValue;
};

export default convertPercentToFraction;
